module.exports = __webpack_public_path__ + "img/chever_down.76d2700e.svg";